import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom';

import sanitizeHtml from 'sanitize-html';

import useFetch from '../../../../hook/useFetch'

import { useDispatch, useSelector } from 'react-redux'

import { getLandingPage } from '../../../../pages/features/landingpage/landingpageSlice'


import { colors } from '../../../../colors'
import { NewspaperData } from '../../../../newspaperdata'
import { ExternalResourcesData } from '../../../../externalresdata'
import { 
    InnerContainer,
    // ImageContainer,
 } from '../../../../components/newPaperFeedCard'

import { 
    HeaderContainer,
    NavLink,
 } from '../popularcategories'

 import { vanguard_icon, external } from '../../../../assets'

const NewsPaperFeed = () => {

    const dispatch = useDispatch

    const { landingPage, landingStatus} = useSelector(state => state?.landingPage)
    useFetch(getLandingPage);

    // Remove space between words
    // const str = 'a very long string';
    // const strUnderscores = str.replaceAll(' ', '_');

    // console.log(strUnderscores); // 



  return (
    <Container>

        <section>
            <NewsContainer>
                <HeaderContainer>
                    <h3>Top Open Access Publications</h3>
                    <h5> <NavLink to='/open-access-resources' >View all</NavLink> </h5>
                </HeaderContainer>
            {
                landingPage?.recentlyModifiedExternalResources?.slice(0, 3).map((external) => {
                    return(
                        <CardContainer key={external?.resourceId} >
                            <LinkToDetails to={`/open-access/resource/${external.resourceNlnCode} `} >
                            <InnerContainer>
                            <ImageContainer src={external?.resourceImage} alt='newspaper_icon' />

                            <Title>
                                <h4>
                                    {external?.resourceTitle.substring(0, 30)}
                                </h4>

                                {/* <h5>{external?.resourceDescription}</h5> */}
                                <h5 dangerouslySetInnerHTML={{ __html: sanitizeHtml(external?.resourceDescription.substring(0, 100)) }} />

                                {/* <p dangerouslySetInnerHTML={{ __html: char }} /> */}
                            </Title>
                            </InnerContainer>
                            </LinkToDetails>
                        </CardContainer>
                    )
                        
                        
                    
                })
            }
            </NewsContainer>

            <NewsContainer>
                <HeaderContainer>
                    <h3>Top News Platforms</h3>
                    <h5> <NavLink to='/nigerian-newspapers' >View all</NavLink> </h5>
                </HeaderContainer>
            {
                landingPage?.newspapers?.slice(0, 3).map((news) => {
                    // console.log(landingPage?.newspapers);
                    return(
                        <CardContainer key={news?.newspaperId} >
                            <InnerContainer>
                            <InitialsContainer  >
                                {news?.newspaperName.substring(0, 1)}
                            </InitialsContainer  >

                            <Title>
                                <a href={news?.newspaperURL} target='_blank'>
                                    {news?.newspaperName}
                                </a>

                                <h5 dangerouslySetInnerHTML={{ __html: sanitizeHtml(news?.newspaperDescription.substring(0, 100) + '...')}}></h5>
                            </Title>
                            </InnerContainer>
                        </CardContainer>
                    )
                        
                        
                    
                })
            }
            </NewsContainer>
        </section>

        
    </Container>
  )
}

const Container = styled.div`
    width: 100%;
    max-width: 1250px;
    margin: 0 auto;
    margin-top: 20px;

    & > section {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        @media screen and (max-width: 600px){
            flex-direction: column;
        }

    }
    

    @media screen and (max-width: 600px){
            
            padding: 0 20px;
        }
    
`

const CardContainer = styled.div`
        width: 100%;
        margin-top: 10px;
        border-bottom: 2px solid #D0D5DD;
        border-radius: 4px;
        cursor: pointer;
`

export const Title = styled.div`

    margin-top: 10px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    
    & a{
        font-size: 16px;
        color: #000;
        align-self: flex-start;
        font-weight: 600;

        &:hover{
            opacity: 0.7;
            transition: 0.5s ease-in-out;
        }
    }

    & > h4{
        align-self: flex-start;
        font-size: 15px;
        font-weight: 600;
        color: #000;
    }

    & h5{
        align-self: flex-start;
        font-size: 12px;
        color: ${colors.faint_text};

        & > p{
            font-size: 12px;
        }
    }
`

const LinkToDetails = styled(Link)`
    text-decoration: none;
    color: #000;
`


const NewsContainer = styled.div`
    width: 47%;
    /* display: grid; */
    /* grid-template-columns: 48% 48%; */
    column-gap: 2rem;

    @media screen and (max-width: 600px){
        display: block;

        @media screen and (max-width: 600px){
            margin-top: 15px;
            width: 100%;
        }
    }
`

const ImageContainer = styled.img`
    border-radius: 2px;
    height: 60px;
    width: 60px;
    /* border: 1px solid red; */

    @media screen and (max-width: 600px){
            height: 50px;
        }
    
`

const InitialsContainer = styled.div`
    border-radius: 2px;
    /* height: 60px; */
    width: 60px;
    border: 1px solid green;
    text-align: center;
    font-weight: 600;
    font-size: 30px;
    
    

    @media screen and (max-width: 600px){
            height: 50px;
        }
    
`

export {NewsPaperFeed}